// react core
import React from 'react';
import { useState } from 'react';
import { Link } from "react-router-dom";
// libs
import { AUTH } from 'api/account';
import { route_to_full_url, deep_clone_obj } from 'utils/helpers';
import usePageTitle from 'utils/page_title';
// components
import UserLogged from 'components/commons/user_logged';
import RedirectTo from 'components/commons/redirect_to';
import ErrorMessage from 'components/commons/error_msg';
import IsEmailValidator from 'components/commons/is_email_validator';
import AjaxSpinner from 'components/commons/ajax_spinner';
import ShowAndHidePassword from 'components/commons/show_hide_pass';
// conf
import conf from 'conf/config';
import { check_if_email } from 'utils/helpers';

function ButtonSender({on_click, username, password})
{
    if(password.length > 1  && check_if_email(username))
    {
        return (
            <button onClick={on_click}>Log In</button>
        )
    }
    else
    {
        return (
            <button disabled>Log In</button>
        )
    }
}


export default function LoginPage({ user, set_user_data })
{
    usePageTitle('Log In');
    // manage error
    const [errors, set_errors] = useState(false);
    const [error_msg, set_error_msg] = useState('');
    // logged flag
    const [logged, set_logged] = useState(false);
    // default data
    const [user_data, _set_user_data] = useState(
    {
        username: '',
        password: ''
    });

    const [is_await, set_is_await] = useState(false);
    const set_field = (field, value) =>
    {
        set_errors(false);
        _set_user_data({ ...user_data, [field]: value });
    };


    // send credentials
    const handle_login = (evt) =>
    {
        evt.stopPropagation();
        evt.preventDefault();
        const send_data = async () =>
        {
            const response = await AUTH.login(user_data.username, user_data.password)
            if (response.ok)
            {
                const data = await response.json();
                if (data.status === 'ok')
                {
                    let tmp = deep_clone_obj(user);
                    tmp.username = data.userinfo.userid;
                    tmp.fullname = data.userinfo.fullname;
                    tmp.status = 'logged';
                    tmp.ok = true;
                    set_user_data(tmp);
                    set_errors(false);
                    set_logged(true);
                    set_is_await(false);
                }
                else
                {
                    set_error_msg('maybe a server error?');
                    set_errors(true);
                    set_is_await(false);
                }
            }
            else
            {
                set_is_await(false);
                const data = await response.json();
                if (data.error && data.error.message)
                {
                    set_error_msg(data.error.message);
                    set_errors(true);
                }
            }
        }
        set_is_await(true);
        // call the function
        send_data().catch(console.error);
    };

    if(logged)
    {
        const came_from = user.came_from || conf.server.default_redirect_after_login;
        return ( <RedirectTo url={came_from} /> );
    }
    else
    {
        // logged previusly
        if(user.ok === true && user.username !== '')
        {
            return ( <UserLogged /> );
        }
        let classess = (errors) ? 'auth-form error' : 'auth-form';
        classess += is_await ? ' loading' : '';
        return (
            <>
                <h2>
                    Log in to the CCH<sup>&reg;</sup> Tagetik Community!
                </h2>
                <AjaxSpinner show={is_await} />
                <form id="login-form" action="#"  className={classess}>
                    <div className='auth-form-errors'>
                        <i className="fa-solid fa-circle-exclamation"></i>
                        <ErrorMessage display={errors} msg={error_msg} />
                    </div>
                    <fieldset>
                        <div className="auth-form-field">
                            <input
                                name="username"
                                id="login-form-username"
                                type="text"
                                required
                                autoComplete="username"
                                value={user_data.username}
                                placeholder="Your business email address"
                                onChange={(e) => set_field("username", e.target.value)}
                            />
                            <label htmlFor="login-form-username">Your business email address <IsEmailValidator username={user_data.username} /></label>
                        </div>
                        <div className="auth-form-field">
                            <ShowAndHidePassword
                                autohide="true"
                                name="password"
                                id="login-form-password"
                                required
                                autoComplete="current-password"
                                value={user_data.password}
                                placeholder="Password"
                                onChange={(e) => set_field("password", e.target.value)}
                            />
                            <label htmlFor="login-form-password">Password</label>
                            <p>
                                <Link to={route_to_full_url("forgot_password")}>Forgot your password?</Link>
                            </p>
                        </div>
                    </fieldset>
                    <div className='auth-form-buttons'>
                        <ButtonSender username={user_data.username} password={user_data.password} on_click={handle_login} />
                    </div>
                </form>
                <p>
                    <strong>New user?</strong><br /> If you don't have an account in the CCH<sup>&reg;</sup> Tagetik
                    Community, start the <Link className="primary" to={route_to_full_url("register")}>registration procedure</Link>
                </p>
            </>
        );
    }
};
